import { getTeamUrl } from 'Common'

export default (values) => async () => {

  window.location = getTeamUrl(`history?date=${values.date}`, 'exports')
}